import React from "react";
import PropTypes from "prop-types";

import UIButton from "../UIButton";
import { clx } from "../../../utils/Helpers";
import "./UIApplicantRowActions.scss";

export const UIApplicantRowActionsButton = ({
  danger = false,
  className,
  ...props
}) => (
  <UIButton
    type="button"
    size="small"
    variant="outlined"
    color={danger ? "error" : "inherit"}
    className={clx(
      "ui-applicant-row-actions__button",
      danger && "ui-applicant-row-actions__button--danger",
      className,
    )}
    {...props}
  />
);

UIApplicantRowActionsButton.propTypes = {
  danger: PropTypes.bool,
  className: PropTypes.string,
};

UIApplicantRowActionsButton.defaultProps = {
  danger: false,
  className: "",
};

const UIApplicantRowActions = ({ children, className }) => (
  <div className={clx("ui-applicant-row-actions", className)}>{children}</div>
);

UIApplicantRowActions.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

UIApplicantRowActions.defaultProps = {
  children: null,
  className: "",
};

UIApplicantRowActions.Button = UIApplicantRowActionsButton;

export default UIApplicantRowActions;
